import React from "react";
import { Trans } from "@lingui/macro";

// TODO: think about place for this file
export const BreadcrumbDashboardTitle = <Trans id="breadcrumb.title.dashboard">Dashboard</Trans>;

export const BreadcrumbAddClientTitle = (
  <Trans id="breadcrumb.title.addClient">Create New Client</Trans>
);
